<template>
  <div>
    <Navbar ref="navbarRef" :selectedOption="3" />
    <h4></h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Descripcion</th>
          <th scope="col">EdadMeses</th>
          <th scope="col">VacunaNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="vacunaplan in datosPaginados" :key="vacunaplan.idVacunaPlan">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(vacunaplan.idVacunaPlan)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(vacunaplan.idVacunaPlan)" title="Editar">edit_square</i></td>
          <td>{{vacunaplan.descripcion}}</td>
          <td>{{vacunaplan.edadMeses}}</td>
          <td>{{vacunaplan.vacunaNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteVacunaPlan(vacunaplan.idVacunaPlan)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idVacunaPlan" class="form-label">IdVacunaPlan</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idVacunaPlan" name="idVacunaPlan" v-model="datoVacunaPlan.idVacunaPlan" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Vacuna -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idVacuna" class="form-label"> Vacuna</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idVacuna" name="idVacuna" v-model="datoVacunaPlan.idVacuna">
                      <option v-for="vacuna in vacunas" :value="vacuna.idVacuna" :key="vacuna.idVacuna">
                        {{ vacuna.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Vacuna -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="descripcion" name="descripcion" v-model="datoVacunaPlan.descripcion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="edadMeses" class="form-label">EdadMeses</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="edadMeses" name="edadMeses" v-model="datoVacunaPlan.edadMeses" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarVacunaPlan" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditVacunaPlan" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js'
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
      vacunaplans : [],
      datoVacunaPlan : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      vacunas: [],
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.navbarRef.toggleProcesos()
    this.$refs.navbarRef.toggleReportes()
    this.$refs.navbarRef.toggleParametros()
    this.$refs.navbarRef.toggleAyuda()
    this.fetchVacunas()
  },
  methods : {
    totalPaginas(){
      return Math.ceil(this.vacunaplans.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwvacunaplans/nombre/'+this.nombreBusqueda).then(response=>{
          this.vacunaplans=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.vacunaplans.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwvacunaplans').then(response=>{
      this.vacunaplans=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.vacunaplans.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idVacuna'
        ,'descripcion'
        ,'edadMeses'
      ];
      const requiredFieldsText = [
        'idVacuna'
        ,'descripcion'
        ,'edadMeses'
      ];
      return validarForm(this.datoVacunaPlan, requiredFields, requiredFieldsText);
    },
    async guardarVacunaPlan(){
      if(this.validarForm() === 1){
        try {
          await api.post('/vacunaplans', this.datoVacunaPlan)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "VacunaPlan creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditVacunaPlan(){
      if(this.validarForm() === 1){
        try {
          await api.post('/vacunaplans', this.datoVacunaPlan)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "VacunaPlan creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoVacunaPlan={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idVacunaPlan){
      this.modalWindow = true
      if(idVacunaPlan != null){    
           api.get('/vwvacunaplans/'+idVacunaPlan).then(resp=>{
          this.datoVacunaPlan = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idVacunaPlan){
      if(idVacunaPlan != null){
        this.$router.push('/vacunaplanmd/'+idVacunaPlan)
      }
    },
    async deleteVacunaPlan (idVacunaPlan) {
      try{
        await api.delete('/vacunaplans/'+idVacunaPlan)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchVacunas() {
      fetch('http://localhost:8080/api/v1/vacunas')
        .then(response => response.json())
        .then(data => {
          this.vacunas = data;
        })
        .catch(error => {
          console.error('Error fetching vacunas:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
